import React, { Component } from "react"
import PropTypes from "prop-types"

import InputField from "./InputField"
import styles from "./TextChoice.module.sass"
import MDSpinner from "react-md-spinner"

class EmailAddressField extends Component {
  static propTypes = {
    choices: PropTypes.object,
    doneCallback: PropTypes.func,
    type: PropTypes.string,
    labels: PropTypes.object,
    stepName: PropTypes.string,
    locale: PropTypes.string,
    selected: PropTypes.object,
    onSelectedUpdate: PropTypes.func,
    onCaptureBuyerEmailAddress: PropTypes.func,
    emailAddressTranslations: PropTypes.object,
    renderAppendToStep: PropTypes.func,
    isSellYourCar: PropTypes.bool,
  }

  state = {
    value: { ...(this.props.selected || this.props.choices) },
    agreedToConsent: false,
    emailSubmitted: false,
    emailBlank: false,
    consentError: false,
    invalidEmail: false,
  }

  componentDidMount() {
    this.updateRenderAppendToStep()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.emailSubmitted !== prevState.emailSubmitted) {
      this.updateRenderAppendToStep()
    }
  }

  componentWillUnmount() {
    this.props.renderAppendToStep(null)
  }

  updateRenderAppendToStep = () => {
    this.props.renderAppendToStep(
      <button
        onClick={this.finished}
        type="button"
        className={`
        main-cta
        ${this.props.isSellYourCar
            ? `uds-button primary full-width submit`
            : `${styles.confirmButton}`
          }`}
      >
        {this.props.isSellYourCar ? (
          <>
            {this.state.emailSubmitted && (
              <MDSpinner
                singleColor="#fff"
                size={18}
                style={{ marginRight: "5px" }}
              />
            )}
            {this.props.labels.carAssemblageDone}
          </>
        ) : (
          this.props.labels.carAssemblageDone
        )}
      </button>
    )
  }

  done = (value) => {
    if (value.buyer_email) {
      this.props.onCaptureBuyerEmailAddress(value.buyer_email)
    }
    // Send the consent value to be stored onto the lead
    if (this.state.agreedToConsent) {
      value = {
        ...value,
        valuation_consents_attributes: [
          {
            agreed: "1",
            trade_in_consent_id:
              this.props.emailAddressTranslations.consents.id,
          },
        ],
      }
    }
    this.props.doneCallback(value)
  }

  finished = () => {
    if (this.state.emailSubmitted) {
      return
    }
    if (!this.state.agreedToConsent) {
      this.setState({ consentError: true })
    }
    if (
      !this.state.value.buyer_email ||
      (this.state.value.buyer_email &&
        !this.validateEmail(this.state.value.buyer_email))
    ) {
      this.setState({ invalidEmail: true })
    }
    if (
      this.state.value.buyer_email &&
      this.validateEmail(this.state.value.buyer_email) &&
      this.state.agreedToConsent
    ) {
      this.setState({ emailSubmitted: true })
      this.done(this.state.value)
    }
  }

  onConsentChange = () => {
    this.setState((prevState) => ({
      agreedToConsent: !prevState.agreedToConsent,
      consentError: false,
    }))
  }

  valueChanged = (value) => {
    this.setState((prevState) => {
      const newValue = { [Object.keys(prevState.value)]: value }

      // Call the prop function when the value changes
      this.props.onSelectedUpdate &&
        this.props.onSelectedUpdate(this.props.stepName, newValue)
      return {
        value: newValue,
        emailBlank: false,
        invalidEmail: false,
        emailSubmitted: false,
      }
    })
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.finished()
  }

  validateEmail = (value) => {
    const validEmailRegex =
      /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
    return validEmailRegex.test(value)
  }

  onBlur = (e) => {
    if (e.target.value && !this.validateEmail(e.target.value)) {
      this.setState({ invalidEmail: true })
    }
  }

  render() {
    const { labels, emailAddressTranslations } = this.props

    const inputValue = this.state.value[Object.keys(this.state.value)[0]]
    return (
      <div className={styles.outerContainer}>
        <InputField
          type="email"
          value={inputValue}
          locale={this.props.locale}
          onChange={this.valueChanged}
          onKeyDown={this.handleKeyDown}
          onBlur={this.onBlur}
          openRight
          autoFocus
          inputPlaceholder="user@example.com"
          label={labels.placeholders[this.props.stepName]}
          aria-describedby={this.state.emailBlank ? "emailBlankError" : this.state.invalidEmail ? "invalidEmailError" : undefined}
          aria-invalid={this.state.emailBlank ? "true" : this.state.invalidEmail ? "true" : undefined}
          autocomplete="email"
        />
        {this.state.emailBlank && (
          <p id="emailBlankError" className={styles.error}>{emailAddressTranslations.email_blank}</p>
        )}
        {this.state.invalidEmail && (
          <p id="invalidEmailError" className={styles.error}>
            {emailAddressTranslations.invalid_email}
          </p>
        )}

        <div className={styles.consentRow}>
          <input
            type="checkbox"
            name="emailConsent"
            id="emailConsent"
            required
            onChange={this.onConsentChange}
            aria-describedby={this.state.consentError ? "emailConsentError" : undefined}
            aria-invalid={this.state.consentError ? "true" : undefined}
          />
          <label htmlFor="emailConsent">
            <span
              className={
                emailAddressTranslations.consents.terms
                  ? styles.consentTextHeadline
                  : styles.consentTextSingle
              }
            >
              {emailAddressTranslations.consents.text}
              <span className={styles.requiredStar}> *</span>
            </span>
            {emailAddressTranslations.consents.terms && (
              <span className={styles.consentTerms}>
                {emailAddressTranslations.consents.terms}
              </span>
            )}
          </label>
        </div>

        {this.state.consentError && (
          <p id="emailConsentError" className={styles.error}>
            {emailAddressTranslations.agree_to_terms}
          </p>
        )}
      </div>
    )
  }
}

export default EmailAddressField
